import script from "./LinkBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkBox.vue?vue&type=script&setup=true&lang=ts"

import "./LinkBox.vue?vue&type=style&index=0&id=bb7d9098&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7d9098"]])

export default __exports__